<app-header #header ></app-header>
<app-navigation-bar (onBurgerClicked)="toggleDrawer()"></app-navigation-bar>
<app-drawer [open]="drawerIsOpen" (onClose)="drawerIsOpen=false"></app-drawer>

<div class="offers-header txt-algn-cntr">
    <h1>{{getString('giftCardDealsTitle')}}</h1>
    <div class="left-header">
      <h2><img src="./assets/images/blue_check_icon_2.png" class="check-icon">
      {{getString('updatedDaily')}}</h2>
      <h2><img src="./assets/images/blue_check_icon_2.png" class="check-icon">
      {{getString('onlineAndRetailStores')}}</h2>
      <h2><img src="./assets/images/blue_check_icon_2.png" class="check-icon">
      {{getString('saveUpToXPercent')}}</h2>
    </div>
    <img src="./assets/images/app_store_and_itunes.png" alt="apple gift card" class="header-card">
  </div>

<div class="page-content">

  <h2>{{getString('iTunesGiftCards')}}</h2>
  <div class="gift-cards-text"><span>{{getString('giftCardsText')}}</span></div>

  <div class="small-horizontal-border"></div>

  <div class="filter-test">
    <app-dropdown class="dd-test" [label]="getString('type')" [items]="shippingTypes" [selectedItem]="shippingType" [stringAttr]="'value'" (onItemSelected)="typeChanged($event)"></app-dropdown>
  </div>

  <div *ngIf="cardDeals && cardDeals.length > 0">

    <div class='submit-deal-container'>
      <div class="left-box">
        <div class="missing-deal">{{getString('dealIsMissing')}}</div>
        <button class="blue-button" type="button" (click)="submitDeal()">{{getString('submitDeal')}}</button>
      </div>

      <app-toggle-switch class="right-box" #toggleSwitch [layout]="1" [checked]="emailNotificationsActive" [label]="getString('emailNotificationsGiftCard')" (onChange)="emailNotificationsClick($event)"></app-toggle-switch>

    </div>

    <div class="card-deal-items">
      <ng-container *ngFor="let cardDeal of cardDeals; let i = index">
        <app-card-deal-item [deal]="cardDeal" (onNoAuth)="showRegister()" (onNewComment)="newCommentAdded(cardDeal)" [showComments]="showComments(cardDeal)"></app-card-deal-item>
        <!-- TEMPORARILY DISABLED: Google Ads -->
        <!-- <app-ad-banner *ngIf="i == 0" [type]="3"></app-ad-banner> -->
      </ng-container>
    </div>

  </div>

  <div *ngIf="!cardDeals || cardDeals.length == 0" class="no-cards-container">
    <img class="no-cards-img" src="./assets/images/multiple_cards.png">
    <div class="no-cards-title">{{getString('noCardsTitle')}}</div>
    <div class="small-horizontal-border short-border"></div>
    <div class="no-cards-text">{{getString('youKnowADeal')}}</div>
    <button class="blue-button" type="button" (click)="submitDeal()">{{getString('submitDeal')}}</button>

    <!-- TEMPORARILY DISABLED: Google Ads -->
    <!-- <app-ad-banner [type]="3"></app-ad-banner> -->

  </div>

  <div *ngIf="isLoading" class="spinner-container txt-algn-cntr">
    <app-spinner></app-spinner>
  </div>

  <app-feedback-smiley *ngIf="cardDeals && cardDeals.length > 0"></app-feedback-smiley>

</div>

<app-home-footer></app-home-footer>

<app-modal #newCardDealPopup [title]="getString('newCardDealTitle')">
  <app-new-card-deal *ngIf="newCardDealPopup.isOpen" (onClose)="newCardDealClose($event)"></app-new-card-deal>
</app-modal>
